package com.devsusana.portfolio.models

/**
 * Represents a showcased software project in the portfolio.
 */
data class Project(
    val id: String,
    val title: String,
    val subtitle: String,
    val description: String,
    val longDescription: String,
    val iconPath: String,
    val bannerPath: String,
    val screenshots: List<String>,
    val tags: List<String>,
    val githubUrl: String?,
    val playStoreUrl: String?,
    val isFeatured: Boolean = false,
    val architectureHighlights: List<String>,
    val keyFeatures: List<String>
)
